import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Container,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  Divider
} from '@mui/material';


import {
  Delete as DeleteIcon,
  Add as AddIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  
} from '@mui/icons-material';
import { ErrorMessage, successMessage } from '../Message';
import { delete_Role, LoadRoles, newRole, updateRole } from '../BaseURL';


function Role() {


        const [roles, setRoles] = useState([]);
        const [searchTermRole, setSearchTermRole] = useState('');
        const [openDialog, setOpenDialog] = useState(false);
        const [editingRole, setEditingRole] = useState(null);
        const [viewMode, setViewMode] = useState('table'); // 'table' or 'card'
       
      
        const [formData, setFormData] = useState({name: ''});
        const filteredRoles = roles.filter(role =>
          role.role.toLowerCase().includes(searchTermRole.toLowerCase())
        
        );
      
        const handleOpenDialog = (role = null) => {
          if (role) {
            setEditingRole(role);
            setFormData({
              name: role.role,
             
            });
          } else {
            setEditingRole(null);
            setFormData({
              name: '',
             
            });
          }
          setOpenDialog(true);
        };
      
        const handleCloseDialog = () => {
          setOpenDialog(false);
          setEditingRole(null);
          setFormData({
            name: '',
            icon: '',
            accessLevel: '',
            responsibilities: ['']
          });
        };
      
    
        useEffect(()=>{
            loadRoles()
        },[])

     const loadRoles =async()=>{
  
       try {
              const response = await axios.get(LoadRoles);
              if (response.data.success) {
              
              setRoles(response.data.results); 
              
              }
              
          } catch (error) {
              await Swal.fire({
              title: 'Error',
              text: error.response?.data?.message || 'Failed to Load Data',
              icon: 'error'
              });
              
          }
  
    }

    
        const handleSubmit = async() => {
          if (!formData.name ) {
           ErrorMessage('Error' ,'No Role Information Found')
            return;
          }
      
         // const filteredResponsibilities = formData.responsibilities.filter(r => r.trim());

         const result = await Swal.fire({
            title: 'Confirm / Cancel',
            text: "Are You Sure You Want To Save Role Information ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes Confirm'
          });

          if (result.isConfirmed) {
            Swal.fire({
              title: 'Processing.......',
              text: 'Please wait',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });     
        
            
      
          if (editingRole) {
            
            
            try {
            
            const response = await axios.put(updateRole(editingRole.id), formData);
            
            if (response.data.success) {
    
            successMessage('Save',response.data.message)

            handleCloseDialog()
            loadRoles()
            
            }
                
            } catch (error) {

                await Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to Save',
                icon: 'error'
                });
            
                
            }

        } else {

        try {

 
       const response = await axios.post(newRole ,formData);
                
        if (response.data.success) {
                
        successMessage('Save',response.data.message)
        loadRoles()
         setFormData({
              name: '',
             
            });
      
        }
            
            } catch (error) {

               await Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Failed to Save',
                icon: 'error'
                });
            }

            
 }
          }
      
          //handleCloseDialog();
        };
      
        const handleDeleteRole = async(roleId) => {
         

            const result = await Swal.fire({
            title: 'Confirm / Cancel',
            text: "Are you sure you want to delete this role?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes Confirm'
          });

          if (result.isConfirmed) {
            Swal.fire({
              title: 'Processing.......',
              text: 'Please wait',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });     
          Swal.fire({
            title: 'Processing...',
            text: 'Please wait',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });


           if (result.isConfirmed) {
            const response = await axios.delete(delete_Role(roleId));
            if (response.data.success) {
                 successMessage('Delete',response.data.message)
                 loadRoles()
                  setFormData({
              name: '',
             
            });
               
                }
              }

        }
        };
      
       
  return (
    <div>
         <Container  maxWidth="xl" sx={{ py: 4 }}>
                          
                    
                          <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
                            Roles Management System
                          </Typography>
                    
                          {/* Search and Controls */}
                          <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
                            <TextField
                              placeholder="Search roles..."
                              value={searchTermRole}
                              size="small"
                              onChange={(e) => setSearchTermRole(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon />
                                  </InputAdornment>
                                )
                              }}
                              sx={{ flexGrow: 1 }}
                            />
                            <Button
                              variant="contained"
                              startIcon={<AddIcon />}
                              onClick={() => handleOpenDialog()}
                              
                             sx={{
                                   width: { xs: '100%', sm: 'auto' },
                                   borderRadius: 2,
                                   px: 3,
                                   py: 1,
                                   textTransform: 'none',
                                   fontSize: '0.95rem',
                                   fontWeight: 500
                                 }}
                            >
                              Add Role
                            </Button>
                          </Box>
                    
                          {/* Roles Display */}
                          {viewMode === 'table' ? (
                            <TableContainer component={Paper}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                   <TableCell sx={{ 
                                    fontWeight: 600,
                                    color: 'text.secondary',
                                    fontSize: '0.875rem',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    py: 2
                                }}>
                                    Role
                                    </TableCell>
                                    <TableCell align="center">ACTION</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {filteredRoles.map((role) => (
                                    <TableRow key={role.id}>
                                      <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                          
                                          <Typography variant="body1" sx={{ mr: 2 }} >{role.role}</Typography>
                                        </Box>
                                      </TableCell>
                                    
                                      <TableCell align="center">
                                        <IconButton onClick={() => handleOpenDialog(role)} color="primary">
                                          <EditIcon />
                                        </IconButton>
                                        <IconButton onClick={() => handleDeleteRole(role.id)} color="error">
                                          <DeleteIcon />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            ''
                          )}
                    
                          {/* Add/Edit Role Dialog */}
                          <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                            <DialogTitle>
                              {editingRole ? 'Edit Role' : 'Add New Role'}
                            </DialogTitle>
                            <DialogContent>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                                <TextField
                                  label="Role Name"
                                  value={formData.name}
                                  onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                                  required
                                  fullWidth
                                />
                    
                                <Divider />
                                
                              </Box>
                            </DialogContent>
                            <DialogActions>
                              <Button variant='outlined' onClick={handleCloseDialog} startIcon={<CancelIcon />}>
                                Cancel
                              </Button>
                              <Button onClick={handleSubmit} variant="contained" startIcon={<SaveIcon />}>
                                {editingRole ? 'Update' : 'Add'} Role
                              </Button>
                            </DialogActions>
                          </Dialog>
                    
                         
        </Container>
    </div>
  )
}

export default Role